module.exports = __webpack_public_path__ + "img/place.a5e703e5.svg";